import React, {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../helpers/AssetHelpers'

function AuthLayout() {
    useEffect(() => {
        const root = document.getElementById('root')
        if (root) {
            root.style.height = '100vh'
        }
        return () => {
            if (root) {
                root.style.height = 'auto'
            }
        }
    }, [])

    return (
        <div className="container-fluid g-0 vh-100 overflow-hidden">
            <div className="row g-0 h-100">
                {/* Left Column - Form Section */}
                <div className="col-lg-6 d-flex flex-column h-100">
                    <div className="d-flex flex-column h-100 px-4 px-md-5 py-5">
                        {/* Main Content - Will grow to fill available space */}
                        <div className="flex-grow-1 d-flex flex-center flex-column">
                            <div className="w-100 w-md-500px">
                                <Outlet/>
                            </div>
                        </div>

                        {/* Footer - Fixed at bottom */}
                        <div className="py-3">
                            <div className="d-flex justify-content-center fw-semibold text-muted fs-sm">
                                <Link to="/terms-and-conditions" className="px-3 text-decoration-none">
                                    Terms & Conditions
                                </Link>
                                <span className="px-1">|</span>
                                <Link to="/contact-us" className="px-3 text-decoration-none">
                                    Contact Us
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Column - Banner Section */}
                <div
                    className="col-lg-6 d-none d-lg-flex align-items-center justify-content-center bg-primary p-10"
                    style={{
                        backgroundImage: `url(${toAbsoluteUrl('media/misc/auth-bg.png')})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                >
                    <div className="text-white text-center px-5">
                        <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>Welcome to Eyeconx!</h1>
                        <p className="lead">
                            Eyeconx enables your practice to effortlessly and instantly send reminders,
                            recalls, notifications and education to patients via e-mails, SMS and telephone.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuthLayout